import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { clubsApi, universalApi } from "../api/api"
import { accessGlobalMiscState } from "../stores/misc"

const useClubs = (clubTypeId: number, triggerFetch: number) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        setData([])
        const response = await simpleGetter(clubsApi.getAll, clubTypeId)
        if (response.list) {
            setData(response.list)
            accessGlobalMiscState().set(`clubsAmount_${clubTypeId}`, response.list.length)
        }
    }

    useEffect(() => {
        if (clubTypeId) {
            fetchData()
        }
    }, [clubTypeId, triggerFetch])

    return data
}

export {
    useClubs
}